import React, { useEffect, useState } from 'react';

import ViewportImageScrollbar from './ViewportImageScrollbar';
import CustomizableViewportOverlay from './CustomizableViewportOverlay';
import ViewportOrientationMarkers from './ViewportOrientationMarkers';
import ViewportImageSliceLoadingIndicator from './ViewportImageSliceLoadingIndicator';
import ReactDOM from 'react-dom';
import CkbImagemChave from './CkbImagemChave';

function CornerstoneOverlays(props) {
  const { viewportIndex, element, scrollbarHeight, servicesManager, viewportData, displaySets, viewportId } = props;
  const { cornerstoneViewportService } = servicesManager.services;
  const [imageSliceData, setImageSliceData] = useState({
    imageIndex: 0,
    numberOfSlices: 0,
  });

  const [stateObjImageKey, setStateObjImageKey] = useState({ SeriesInstanceUID: "", StudyInstanceUID: "", SOPInstanceUID: "" });
  const [stateSerie, setStateSerie] = useState("");

  function getActiveImage() {

    try {

      if (viewportData === null) return;

      const getEnabledElements = cornerstone.getEnabledElements();

      if (getEnabledElements.length === 0 || getEnabledElements === undefined || getEnabledElements === null)
        return;

      const viewport = getEnabledElements[viewportIndex].viewport;

      const imageIndex = viewport.getTargetImageIdIndex();

      const { data } = viewportData;
      const { StudyInstanceUID, imageIds } = data;

      const objImageKey = {
        SeriesInstanceUID: imageIds[imageIndex].split('series/')[1].split('/instances')[0],
        StudyInstanceUID: StudyInstanceUID,
        SOPInstanceUID: imageIds[imageIndex].split('instances/')[1].split('/frames')[0],
      }

      if (objImageKey.SOPInstanceUID !== stateObjImageKey.SOPInstanceUID)
        setStateObjImageKey(objImageKey);

    } catch (ex) {
      console.log(ex);
    }

  }

  useEffect(() => {
    if (viewportData) {
      setTimeout(() => {
        getActiveImage();
      }, 1000);
    }
  }, [viewportData]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.href).getAll("isPacientePortal");
    const shouldRenderComponent = params.length === 0 || params[0] === 'false';

    if (stateObjImageKey) {
      if (stateObjImageKey.SOPInstanceUID) {
        const el = document.getElementsByClassName('imagemChaveSerie')[0];
        if (el) {
          el.id = `${el.id}_${stateObjImageKey.SOPInstanceUID}`
          el.classList.remove("imagemChaveSerie");
          el.classList.add(el.id);
          setStateSerie(el.id);
          ReactDOM.render(shouldRenderComponent && <CkbImagemChave stateObjImageKey={stateObjImageKey} />, el);
          return;
        }

        const newEl = document.getElementsByClassName(stateSerie)[0];
        if (newEl) {
          ReactDOM.unmountComponentAtNode(newEl);
          ReactDOM.render(shouldRenderComponent && <CkbImagemChave stateObjImageKey={stateObjImageKey} />, newEl);
          return;
        }

      }
    }
  }, [stateObjImageKey]);

  getActiveImage();

  useEffect(() => {
    const { unsubscribe } = cornerstoneViewportService.subscribe(
      cornerstoneViewportService.EVENTS.VIEWPORT_DATA_CHANGED,
      props => {
        if (props.viewportIndex !== viewportIndex) {
          return;
        }
      }
    );

    return () => {
      unsubscribe();
    };
  }, [viewportIndex]);

  if (!element) {
    return null;
  }

  if (viewportData) {
    const viewportInfo =
      cornerstoneViewportService.getViewportInfoByIndex(viewportIndex);

    if (viewportInfo?.viewportOptions?.customViewportProps?.hideOverlays) {
      return null;
    }
  }

  return (
    <div className="noselect">
      <ViewportImageScrollbar
        viewportIndex={viewportIndex}
        viewportData={viewportData}
        element={element}
        imageSliceData={imageSliceData}
        setImageSliceData={setImageSliceData}
        scrollbarHeight={scrollbarHeight}
        servicesManager={servicesManager}
      />

      <CustomizableViewportOverlay
        imageSliceData={imageSliceData}
        viewportData={viewportData}
        viewportIndex={viewportIndex}
        servicesManager={servicesManager}
        element={element}
        viewportId={viewportId}
      />

      <ViewportImageSliceLoadingIndicator
        viewportData={viewportData}
        element={element}
      />

      <ViewportOrientationMarkers
        imageSliceData={imageSliceData}
        element={element}
        viewportData={viewportData}
        servicesManager={servicesManager}
        viewportIndex={viewportIndex}
      />
    </div>
  );
}

export default CornerstoneOverlays;
